export const ADD_MONEY_FROM_PAYPAL_START =
  'ADD_MONEY_FROM_PAYPAL_START';
export const ADD_MONEY_FROM_PAYPAL_SUCCESS =
  'ADD_MONEY_FROM_PAYPAL_SUCCESS';
export const ADD_MONEY_FROM_PAYPAL_ERROR =
  'ADD_MONEY_FROM_PAYPAL_ERROR';
export const ADD_MONEY_FROM_PAYPAL_END = 'ADD_MONEY_FROM_PAYPAL_END';
export const CLEAR_ADD_MONEY_FROM_PAYPAL_STORE =
  'CLEAR_ADD_MONEY_FROM_PAYPAL_STORE';
